<div class="flex flex-col p-8 bg-card shadow rounded overflow-hidden mr-4">
  <p class="text-lg font-medium">{{ title }}</p>
  <mat-divider class="mt-8 mb-10"></mat-divider>
  <div class="flex flex-col gt-sm:flex-row">
    <form [formGroup]="dropdownForm">
      <div class="add-label" [formGroupName]="'newOption'" *ngIf="!disableAddNew">
        <div class="label">
          <mat-form-field>
            <mat-label>New Value</mat-label>
            <input matInput [formControlName]="'name'" />
            <button
              mat-icon-button
              matSuffix
              [disabled]="!dropdownForm.get('newOption').valid || !dropdownForm.get('newOption').dirty"
              (click)="addOption()"
            >
              <mat-icon [svgIcon]="'add'"></mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <div class="labels" [formArrayName]="'options'" cdkDropList (cdkDropListDropped)="drop($event)">
        <div class="label flex flex-auto" *ngFor="let option of dropdownForm.get('options')['controls']" cdkDrag>
          <div class="drag-handle dropdown-drag" cdkDragHandle [matTooltip]="'ID: ' + option.get('id').value">
            <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
          </div>
          <mat-form-field>
            <mat-label></mat-label>
            <input matInput [formControl]="option.get('name')" />
            <span matSuffix *ngIf="showRelatedTo" matTooltip="Related To">
              {{ getRelatedToLabel(option.get('relatedTo').value) }}</span
            >
            <button mat-icon-button matSuffix (click)="showHideOption(option)" *ngIf="option.get('hidden').value">
              <mat-icon [svgIcon]="'visibility_off'"></mat-icon>
            </button>
            <button mat-icon-button matSuffix (click)="showHideOption(option)" *ngIf="!option.get('hidden').value">
              <mat-icon [svgIcon]="'visibility'"></mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field *ngIf="showColor" class="w-1/6">
            <mat-label></mat-label>
            <mat-select
              class="calendar-color-selector"
              [(value)]="option.get('color').value"
              [panelClass]="'calendar-sidebar-calendar-edit-panel-color-select-panel'"
              [disableOptionCentering]="true"
              matPrefix
            >
              <mat-select-trigger>
                <mat-icon [ngClass]="'text-' + option.get('color').value + '-500'" [svgIcon]="'color_lens'"> </mat-icon>
              </mat-select-trigger>
              <div class="color-box-title">Color</div>
              <div class="color-box-container">
                <mat-option *ngFor="let color of calendarColors" [value]="color" #matOption="matOption">
                  <mat-icon [ngClass]="color" *ngIf="matOption.selected" [svgIcon]="'check'"> </mat-icon>
                  <span class="color-box" [ngClass]="color"></span>
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>
